import React from "react";
import SFSelect from "../../select";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const Wrapper = styled("div")(() => ({
  width: 200,
  minWidth: 200
}));

const FieldSelector = (props) => {
  return (
    <Wrapper>
      <SFSelect
        size="medium"
        selectedValue={props.options.find((x) => x.name === props.value)?.label}
        values={props.options.map((x) => x.label)}
        onChangeFilter={({ name, value }) =>
          props.handleOnChange(
            props.options.find((x) => x.label === value).name
          )
        }
      />
    </Wrapper>
  );
};

export default FieldSelector;
